export default function () {
    return {
      customerList:[],
      customerWaitList:[],
    }
  }